<!--個人基本資料 健康背景-->
<div class="page-container">
  <!--title 標題-->
  <h2 class="page-title">
    @if (step === 1) {
      {{ 'reserve-health.personal-title' | translate }}
    } @else if (step === 2) {
      {{ 'reserve-health.family-title' | translate }}
    } @else if (step === 3) {
      {{ 'reserve-health.subjective-title' | translate }}
    }
  </h2>
  <p class="page-subtitle">
    @if (step === 1) {
      {{ 'reserve-health.subtitle' | translate }}
    } @else if (step === 2) {
      {{ 'reserve-health.family-subtitle' | translate }}
    } @else if (step === 3) {
      {{ 'reserve-health.subjective-subtitle' | translate }}
    }
  </p>
  <div class="card-content register-card-content">
    <!--    <h4>{{ 'reserve-health.title' | translate }}({{ step }}/3)</h4>-->

    @if (step === 1) {
      <!--是否有以下個人病史-->
      <div class="register-card-title-questionnaire">
        <h3 class="register-card-title">
          <span>{{ 'reserve-health.title' | translate }}({{ step }}/3)</span>
          {{ 'reserve-health.do-you-have-following-history' | translate }}
        </h3>
        <div class="input-block">
          <mat-checkbox
            [(ngModel)]="personalNoneOfFollowing"
            (change)="togglePersonalNoneOfFollowing()"
            >{{ 'reserve-health.none-of-following' | translate }}
          </mat-checkbox>
        </div>
      </div>

      <div
        [class.disabled]="personalNoneOfFollowing"
        class="questionnaire-content"
      >
        @for (
          diseaseGroup of personalQuestionnaire?.diseaseGroups;
          let i = $index;
          track i
        ) {
          <div class="input-block step-input-block" 
               [ngClass]="{'hidden-title': diseaseGroup.diseaseType === '肌肉骨骼與外傷相關疾病'}">
            <label class="input-title" 
                   [style.display]="diseaseGroup.diseaseType === '肌肉骨骼與外傷相關疾病' ? 'none' : 'block'">
              {{ diseaseGroup.diseaseType }}
            </label>
            <section class="mat-mdc-checkbox-group">
              @for (
                diseaseOption of diseaseGroup.diseaseOptions;
                let j = $index;
                track j
              ) {
                <!-- 1564: 骨折 1565: 癌症 1566: 其他慢性疾病 -->
                @if (diseaseOption.choiceId !== '1564' && diseaseOption.choiceId !== '1565' && diseaseOption.choiceId !== '1566') {
                  <mat-checkbox
                    [disabled]="personalNoneOfFollowing"
                    [checked]="
                      personalDiseases.includes(
                        diseaseOption.name | personalHistoryDisease
                      ) || personalDiseaseDetails[diseaseOption.choiceId]
                    "
                    (change)="
                      onPersonalDiseaseCheckboxChange(
                        $event.checked,
                        diseaseOption
                      )
                    "
                  >
                    {{ diseaseOption.name }}
                  </mat-checkbox>
                  @if (diseaseOption.detailPlaceholder) {
                    <div
                      class="input-group"
                      #fieldRef
                      [attr.data-choice-id]="diseaseOption.choiceId"
                    >
                      <input
                        matInput
                        [disabled]="personalNoneOfFollowing"
                        [placeholder]="diseaseOption.detailPlaceholder"
                        [(ngModel)]="
                          personalDiseaseDetails[diseaseOption.choiceId]
                        "
                        [ngClass]="{
                          'input-error':
                            showError &&
                            personalDiseaseDetails[diseaseOption.choiceId] === '',
                        }"
                        (compositionstart)="onCompositionStart()"
                        (compositionend)="onCompositionEnd(diseaseOption)"
                        (input)="
                          !isComposing &&
                            onPersonalDiseaseDetailInput(diseaseOption)
                        "
                      />
                      @if (
                        showError &&
                        personalDiseaseDetails.hasOwnProperty(
                          diseaseOption.choiceId
                        ) &&
                        personalDiseaseDetails[diseaseOption.choiceId] === ''
                      ) {
                        <mat-error class="input-error-msg">{{
                          'error.cannot-be-empty' | translate
                        }}</mat-error>
                      }
                    </div>
                  }
                }
              }
            </section>
          </div>
        }
        <!-- 其他病狀本頁面不會用到 到未來會員中心同表單將會用到 -->
        <!--        <div class="input-block">-->
        <!--          <label class="input-title">若您有其他疾病，可直接輸入</label>-->
        <!--          <input [disabled]="personalNoneOfFollowing" class="input-group" matInput-->
        <!--                 [placeholder]="'reserve-health.example-placeholder' | translate"-->
        <!--                 [(ngModel)]="otherPersonalDisease"/>-->
        <!--        </div>-->
      </div>
    } @else if (step === 2) {
      <!--家庭症狀-->
      <div class="register-card-title-questionnaire">
        <h3 class="register-card-title">
          <span>{{ 'reserve-health.title' | translate }}({{ step }}/3)</span>
          {{
            'reserve-health.do-your-family-have-following-history' | translate
          }}
        </h3>
        <div class="input-block">
          <mat-checkbox
            [(ngModel)]="familyNoneOfFollowing"
            (change)="toggleFamilyNoneOfFollowing()"
            >{{ 'reserve-health.none-of-following' | translate }}
          </mat-checkbox>
        </div>
      </div>
      <div
        [class.disabled]="familyNoneOfFollowing"
        class="questionnaire-content"
      >
        @for (
          diseaseGroup of familyQuestionnaire?.diseaseGroups;
          let i = $index;
          track i
        ) {
          <div class="input-block">
            <label class="input-title">{{ diseaseGroup.diseaseType }}</label>
            <section class="mat-mdc-checkbox-group">
              @for (
                diseaseOption of diseaseGroup.diseaseOptions;
                let j = $index;
                track j
              ) {
                <mat-checkbox
                  [disabled]="familyNoneOfFollowing"
                  [checked]="
                    familyDiseases.includes(
                      diseaseOption.name | familyHistoryDisease
                    )
                  "
                  (change)="
                    onFamilyDiseaseChange($event.checked, diseaseOption)
                  "
                >
                  {{ diseaseOption.name }}
                </mat-checkbox>
              }
            </section>
          </div>
        }
        <!--        <div class="input-block">-->
        <!--          <label class="input-title">若您家族成員有其他疾病，可直接輸入</label>-->
        <!--          <input [disabled]="familyNoneOfFollowing" class="input-group" matInput-->
        <!--                 [placeholder]="'reserve-health.example-placeholder' | translate"-->
        <!--                 [(ngModel)]="otherFamilyDisease"/>-->
        <!--        </div>-->
      </div>
    } @else if (step === 3) {
      <!--自覺症狀-->
      <div class="register-card-title-questionnaire">
        <h3 class="register-card-title">
          <span>{{ 'reserve-health.title' | translate }}({{ step }}/3)</span>
          {{
            'reserve-health.do-you-have-following-history-in-pass-three-months'
              | translate
          }}
        </h3>
        <div class="input-block">
          <mat-checkbox
            [(ngModel)]="subjectiveSymptomNoneOfFollowing"
            (change)="toggleSubjectiveSymptomNoneOfFollowing()"
            >{{ 'reserve-health.none-of-following' | translate }}
          </mat-checkbox>
        </div>
      </div>

      <div
        [class.disabled]="subjectiveSymptomNoneOfFollowing"
        class="questionnaire-content"
      >
        @for (
          diseaseGroup of subjectiveSymptomQuestionnaire?.diseaseGroups;
          let i = $index;
          track i
        ) {
          <div class="input-block">
            <label class="input-title">{{ diseaseGroup.diseaseType }}</label>
            <section class="mat-mdc-checkbox-group">
              @for (
                diseaseOption of diseaseGroup.diseaseOptions;
                let j = $index;
                track j
              ) {
                <mat-checkbox
                  [disabled]="subjectiveSymptomNoneOfFollowing"
                  [checked]="
                    subjectiveSymptomDiseases.includes(
                      diseaseOption.name | subjectiveSymptomDisease
                    )
                  "
                  (change)="
                    onSubjectiveSymptomDiseaseChange(
                      $event.checked,
                      diseaseOption
                    )
                  "
                >
                  {{ diseaseOption.name }}
                </mat-checkbox>
              }
            </section>
          </div>
        }
        <!--        <div class="input-block">-->
        <!--          <label class="input-title">其他症狀</label>-->
        <!--          <input [disabled]="subjectiveSymptomNoneOfFollowing" class="input-group" matInput-->
        <!--                 [placeholder]="'reserve-health.example-placeholder' | translate"-->
        <!--                 [(ngModel)]="otherSubjectiveSymptomDisease"/>-->
        <!--        </div>-->
      </div>
    }
    <div class="page-btn-block">
      <button
        mat-button
        (click)="handlePreviousClick()"
        class="btn-outline-primary btn-size-l"
      >
        {{ 'common.button.previous' | translate }}
      </button>
      <button
        mat-button
        (click)="handleNextClick($event)"
        class="btn-fill-primary btn-size-l"
      >
        {{ 'common.button.next' | translate }}
      </button>
    </div>
  </div>
</div>
